<template>
  <div class="statusList">
    <!-- 公共title -->
    <Top :name="$t('设备数据')" :show-button="false"></Top>
    <div class="status-cont">
      <div class=" w-100 text-center" style="color:#909399;font-size: 22px;line-height:230px"
          v-if="statusList.length === 0">
          {{ $t('base.no-data') }}
        </div>
      <div v-for="(status, index) in statusList" :key="index">
        <div class="status">
          <div class="label">{{ status.name }}</div>
          <div
            class="value"
            :style="`color:${status.stat && statusColor[status.stat]};`"
          >
            {{ status.v? status.v +status.unit :''  }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: ["equip_data","measurements_list"],
  name: "status",
  data() {
    return {
      statusColor: {
        // normal: "#00E7FF",
        // error: "#FF706F",
        // warning: "#F8C533"
        0: "#00e7ff",
        1: "#ffd643",
        2: "#ff706f",
      },
      dataName:[
        [
          {name:'实际转速',value:'682',status:"error",unit:'rpm'},
          {name:'运行电流',value:'47.2',status:"error",unit:'A'},
          {name:'驱动端轴承温度',value:'58.1',status:"error",unit:'℃'},
          {name:'工作液入口温度',value:'35.6',status:"error",unit:'℃'},
          {name:'非驱动端轴承振动',value:'2.3',status:"waring",unit:'mm/s'},
          {name:'驱动端轴承振动',value:'3.2',status:"waring",unit:'mm/s'},

        ],
        [
          {name:'电机扭矩',value:'29',status:"error",unit:'N·m'},
          {name:'X向电机振动',value:'-94.9',status:"waring",unit:'mm/s'},
          {name:'Y向电机振动',value:'35.7',status:"normal",unit:'mm/s'},
          {name:'X向泵振动',value:'25.6',status:"normal",unit:'mm/s'},
          {name:'Y向泵振动',value:'23.1',status:"normal",unit:'mm/s'},
          {name:'冷却水温度',value:'13.3',status:"normal",unit:'℃'},
        ],
        [
          {name:'出口压力',value:'950',status:"normal",unit:'mabrG'},
          {name:'入口风量',value:'7804',status:"normal",unit:'Am³/h'},
          {name:'入口温度',value:'40',status:"normal",unit:'°C'},
          {name:'运行电流',value:'331',status:"normal",unit:'A'},

        ]
      ],
      statusList:[]
    };
  },
  watch:{
    "measurements_list":{
      handler(newVal){
        if(newVal){
          if(this.equip_data.is_iot_ready){
            this.statusList = _.cloneDeep(newVal)
          }else{
            this.statusList = []
          }
        } 
      },deep:true
    }
  },
  computed: {
    // statusList() {
    //   return  this.dataName[(this.$route.query.index-1)||0];
    // }
  },
  mounted() {},
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.statusList {
  height: 100%;
  overflow: hidden;
  .status-cont {
    height: 95%;
    // overflow: auto;
    overflow:hidden;
    overflow-y: scroll;
  }
  .status {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }
  .label {
    flex: 1;
  }
  .value {
    flex: 1;
    font-size: 16px;
    line-height: 24px;
    color: #00e7ff;
  }
}
.status-cont::-webkit-scrollbar {
  display: none; /* Chrome Safari */
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}

</style>
